import React from 'react';
interface PaxStatementAgentCustomerProps {
  customer: {
    primaryContact: string;
    email: string;
    phone: string;
    address: string[];
    bookingStatus: string;
  };
  qrCodeUrl?: string;
}
export function PaxStatementAgentCustomer({
  customer,
  qrCodeUrl
}: PaxStatementAgentCustomerProps) {
  return <div className="mb-6" data-id="element-671">
      {/* Customer Information with QR Code */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5" data-id="element-672">
        <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-3" data-id="element-673">
          Customer Information
        </h3>
        <div className="flex gap-6" data-id="element-674">
          {/* Left Column - Customer Details */}
          <div className="flex-1 grid grid-cols-2 gap-x-8 gap-y-2.5" data-id="element-675">
            <div data-id="element-676">
              <p className="text-xs font-medium text-neutral-600" data-id="element-677">
                Primary Contact:
              </p>
              <p className="text-sm font-semibold text-neutral-900" data-id="element-678">
                {customer.primaryContact}
              </p>
            </div>
            <div data-id="element-679">
              <p className="text-xs font-medium text-neutral-600" data-id="element-680">Email:</p>
              <p className="text-sm text-neutral-900" data-id="element-681">{customer.email}</p>
            </div>
            <div data-id="element-682">
              <p className="text-xs font-medium text-neutral-600" data-id="element-683">Phone:</p>
              <p className="text-sm text-neutral-900" data-id="element-684">{customer.phone}</p>
            </div>
            <div data-id="element-685">
              <p className="text-xs font-medium text-neutral-600" data-id="element-686">
                Booking Status:
              </p>
              <p className="text-sm font-semibold text-neutral-900" data-id="element-687">
                {customer.bookingStatus}
              </p>
            </div>
            <div className="col-span-2" data-id="element-688">
              <p className="text-xs font-medium text-neutral-600" data-id="element-689">Address:</p>
              <div className="text-sm text-neutral-900" data-id="element-690">
                {customer.address.map((line, i) => <p key={i} data-id="element-691">{line}</p>)}
              </div>
            </div>
          </div>

          {/* Right Column - QR Code */}
          {qrCodeUrl && <div className="flex flex-col items-center justify-start" data-id="element-692">
              <div className="w-32 h-32 bg-neutral-200 rounded flex items-center justify-center mb-2" data-id="element-693">
                <img src={qrCodeUrl} alt="Booking QR Code" className="w-full h-full object-contain" data-id="element-694" />
              </div>
              <p className="text-xs font-semibold text-neutral-700 text-center uppercase tracking-wide" data-id="element-695">
                Scan to View Booking
              </p>
            </div>}
        </div>
      </div>
    </div>;
}